/**
 * Cache mémoire pour les URLs de photos — Phase 2, incrément 2.2
 * (factorisé sur `blobUrls.ts` en incrément 2.3).
 *
 * Wrapper mince autour de `createBlobUrlCache('photo')` qui expose
 * l'API historique (`setPhotoUrl` / `getPhotoUrlNow` / `clearPhotoUrl`)
 * pour ne pas casser les call sites de 2.2. La logique est désormais
 * dans `blobUrls.ts` — partagée avec `voiceUrls.ts` (2.3).
 *
 * Voir `blobUrls.ts` pour la sémantique (pose immédiate, lazy
 * hydratation IDB, révocation propre).
 */
import { createBlobUrlCache } from './blobUrls.js';

const cache = createBlobUrlCache('photo');

export function setPhotoUrl(photoId: string, url: string): void {
  cache.setUrl(photoId, url);
}

export function getPhotoUrlNow(photoId: string): string | null {
  return cache.getUrlNow(photoId);
}

export function clearPhotoUrl(photoId: string): void {
  cache.clearUrl(photoId);
}

/** @internal pour tests — purge complète. */
export function _resetPhotoUrlsForTests(): void {
  cache.reset();
}

/** @internal pour tests — vérifie si une URL est cachée. */
export function _hasCachedPhotoUrl(photoId: string): boolean {
  return cache.has(photoId);
}
